module.exports = __webpack_public_path__ + "img/lg_ring_y_0_0_0@2x.b1d70fee.png";